<template>
    <div
        class="tr a-promotionLabel overflow-visible"
        :class="{ 'tr--expanded': showMore }"
        v-if="data"
    >
        <div class="tr__upper">
            <div class="tr__actions">
                <a-icon
                    @click.native="
                        showMore = !showMore
                        showMoreProducts()
                    "
                    icon="Dropdown"
                    class="cursor-pointer"
                />
            </div>
            <div class="tr__primary a-promotionLabel__primaryColumn">
                <div class="tr-featured">
                    <div class="tr-featured__image c-fig c-fig--promos">
                        <img
                            v-if="data.logo"
                            :src="data.logo.urls.medium"
                            class="c-fig__img"
                        />
                    </div>
                    <div class="tr-featured__details">
                        <p class="typo typo--name">{{ data.name }}</p>
                        <p class="typo typo--secondary">{{ promoType }}</p>
                        <p class="typo typo--secondary">
                            Od
                            <time datetime>{{ startAt }}</time>
                            do
                            <time datetime>{{ endAt }}</time>
                        </p>
                        <div
                            class="a-promotionLabel__badges d-flex d-xl-none justify-content-end justify-content-sm-start gap-1 mb-3 mb-md-0"
                        >
                            <div
                                v-if="data.loyalty"
                                class="a-badge a-badge--success text-nowrap"
                            >
                                Tylko z aplikacją
                            </div>
                            <div
                                v-if="data.usage_limit_per_loyalty_card"
                                v-tooltip="
                                    `Promocja ma limit użyć na kartę klienta: ${Number(
                                        data.usage_limit_per_loyalty_card
                                    )}`
                                "
                                class="a-badge a-badge--success text-nowrap"
                            >
                                Limit na kartę
                                <a-icon icon="Info" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tr__tertiary">
                <div class="tr-data  a-promotionLabel__products">
                    <div class="tr-data__cell">
                        <span class="tr-data__dt">Liczba produktów</span>
                        <span
                            v-if="data.totalProductsRecords"
                            class="tr-data__dd a-promotionLabel__productsCounter"
                            >{{ data.totalProductsRecords }}</span
                        >
                        <span v-else class="tr-data__dd ">
                            <page-preloader small minHeight="20px" />
                        </span>
                    </div>
                </div>
                <div
                    class="d-none d-xl-flex flex-wrap justify-content-end gap-1"
                >
                    <div
                        v-if="data.loyalty"
                        class="a-badge a-badge--success text-nowrap"
                    >
                        Tylko z aplikacją
                    </div>
                    <div
                        v-if="data.usage_limit_per_loyalty_card"
                        v-tooltip="
                            `Promocja ma limit użyć na kartę klienta: ${Number(
                                data.usage_limit_per_loyalty_card
                            )}`
                        "
                        class="a-badge a-badge--success text-nowrap"
                    >
                        Limit na kartę
                        <a-icon icon="Info" />
                    </div>
                </div>
            </div>
        </div>
        <div
            class="m-promoPreviewDetails tr__drawer is-expandable"
            v-if="showMore"
        >
            <h6 class="typo--headline">Szczegóły</h6>
            <promotion-list-details :promotion="data" />
            <div>
                <product-tree
                    class="--labels-list"
                    :products="products"
                    component-name="LabelListProduct"
                    preview-type="labels"
                    fetching-method-name="loadLabelProducts"
                    :promotion="data"
                />
                <page-preloader
                    v-if="data.productsStatus === 'loading'"
                    min-height="123px"
                />
                <the-btn
                    class="mt-3"
                    v-if="
                        data.productsPagination &&
                            data.productsPagination.nextPage
                    "
                    @click.native="showMoreProducts"
                    >Pokaż więcej produktów
                </the-btn>
            </div>
        </div>
        <div
            class="tr__checkbox custom-control custom-checkbox custom-checkbox-lg d-flex align-items-center justify-content-center"
            style="padding-left: 0 !important; width: 24px"
        >
            <button-spinner
                v-if="loaderSelect === 'loading'"
                class="text-primary"
                :status="loaderSelect"
            />

            <ui-checkbox-input
                v-else
                :name="
                    `${
                        selectLabel ? 'remove-from' : 'add-to'
                    }-card-label ${'c-promos-' + data.id}`
                "
                :disabled="
                    loaderSelect === 'loading' ||
                        !data.totalProductsRecords ||
                        data.productsStatus === 'loading'
                "
                v-model="selectLabel"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PromotionListDetails from '../promotions/promotionsPreview/PromotionListDetails'

export default {
    components: { PromotionListDetails },
    data() {
        return {
            showMore: false,
            checked: false,
            loaderSelect: 'idle'
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        promoTypes: {
            type: Object,
            required: false
        },
        previewType: {
            type: String,
            required: true
        },
        setWeight: {
            type: String,
            required: false
        }
    },

    computed: {
        startAt() {
            return moment(this.data.start_at).format('DD-MM-YYYY, HH:mm')
        },
        endAt() {
            return moment(this.data.end_at).format('DD-MM-YYYY, HH:mm')
        },
        products() {
            let products = []
            if (this.data.products?.length > 0) {
                products = this.data.products
            }
            return products
        },
        selectLabel: {
            get() {
                return this.$store.getters.getSelectedLabelGroupBoolean(
                    this.data.id,
                    this.data.groupId
                )
            },
            async set(value) {
                this.loaderSelect = 'loading'
                await this.$store.dispatch('selectLabelGroupLabel', {
                    promoId: this.data.id,
                    value,
                    groupId: this.data.groupId,
                    groups: this.$store.getters.getLabelGroups
                })
                this.loaderSelect = 'idle'
            }
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.data.type)
        }
    },
    methods: {
        showMoreProducts() {
            if (!this.showMore) return

            if (this.products.length) {
                return
            }

            this.$store.dispatch('loadLabelProducts', {
                params: {
                    promo_id: this.data.id,
                    main: true,
                    per: 100
                },
                promo: this.data
            })
        }
    }
}
</script>
